import { API_ENDPOINTS } from "./endpoints";
import { requestJson, toArray } from "./httpClient";

export const fetchReport = async () => {
    const data = await requestJson(API_ENDPOINTS.reports.summary);
    return toArray(data);
};
